import { Injectable } from '@angular/core';
import { BehaviorSubject, catchError, Observable, of, tap } from 'rxjs';
import { CoordonneesClient } from 'src/app/api/model/coordonnees-client.model';
import { RequeteModifierCoordonnees } from 'src/app/api/model/requete-modifier-coordonnees.model';
import { ErreurSummary } from '../../models/erreurs/erreur-summary';
import { ChangementCoordonneeCreditAccesDService } from '../changement-coordonnee-credit-accesd/changement-coordonnee-credit-acces-d.service';
import { ChangementCoordonneeBancaireAccesDService } from '../changement-coordonnee-bancaire-accesd/changement-coordonnee-bancaire-acces-d.service';
import { ParticulierBancaire } from 'src/app/api/model/particulier-bancaire.model';
import { HttpErrorResponse } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class GlobalStoreService {
  private readonly updateDataForm = new BehaviorSubject<RequeteModifierCoordonnees>(undefined);
  private readonly formErrors = new BehaviorSubject<ErreurSummary[]>(undefined);
  private readonly coordonneesClient = new BehaviorSubject<CoordonneesClient>(undefined);
  private readonly coordonneesMembre = new BehaviorSubject<ParticulierBancaire>(undefined);
  private readonly etatModale = new BehaviorSubject<boolean>(false);
  private readonly etatErreur = new BehaviorSubject<HttpErrorResponse>(undefined);
  private readonly selector = new BehaviorSubject<string>('h1');
  private etatModification: string = null;

  constructor(
    private readonly changementCoordonneeCreditAccesDService: ChangementCoordonneeCreditAccesDService,
    private readonly changementCoordonneeBancaireAccesDService: ChangementCoordonneeBancaireAccesDService
  ) {}

  getUpdateDataForm(): Observable<RequeteModifierCoordonnees> {
    return this.updateDataForm.asObservable();
  }
  saveUpdateDataForm(requeteModifierCoordonnees: RequeteModifierCoordonnees): void {
    this.updateDataForm.next(requeteModifierCoordonnees);
  }

  getCoordonneesClient$(): Observable<CoordonneesClient> {
    if (this.coordonneesClient.value == null) {
      this.changementCoordonneeCreditAccesDService
        .obtenirCoordoonees$()
        .pipe(
          catchError((err) => {
            this.saveEtatErreur(err);
            return of(null);
          }),
          tap((data?: CoordonneesClient) => this.saveCoordonneesClient(data))
        )
        .subscribe();
    }

    return this.coordonneesClient.asObservable();
  }

  getCoordonneesMembre$(): Observable<ParticulierBancaire> {
    if (this.coordonneesMembre.value == null) {
      this.changementCoordonneeBancaireAccesDService
        .obtenirCoordoonees$()
        .pipe(
          catchError((err) => {
            this.saveEtatErreur(err);
            return of(null);
          }),
          tap((data?: ParticulierBancaire) => this.saveCoordonneesMembre(data))
        )
        .subscribe();
    }

    return this.coordonneesMembre.asObservable();
  }

  saveCoordonneesClient = (coordonneesCredit: CoordonneesClient) => this.coordonneesClient.next(coordonneesCredit);
  saveCoordonneesMembre = (coordonneesBancaire: ParticulierBancaire) =>
    this.coordonneesMembre.next(coordonneesBancaire);
  getMembreModification = () => this.coordonneesMembre.asObservable();

  getValeurCoordonneesMembre(): ParticulierBancaire {
    //Pour les cas ou l'on a besoin des coordonnees synchrones et non de l'observable
    return this.coordonneesMembre.value;
  }

  getErrorsForm = () => this.formErrors;
  saveErrorsForm = (erreurSummaries: ErreurSummary[]) => this.formErrors.next(erreurSummaries);

  getSelector = () => this.selector;
  saveSelector = (selector: string) => this.selector.next(selector);

  getEtatModale = () => this.etatModale;
  saveEtatAfficherModaleAnnuler = (etat: boolean) => this.etatModale.next(etat);

  getDeclancherModale = () => sessionStorage.getItem('declencherModale');
  saveDeclancherModale = (declencherModale: string) => sessionStorage.setItem('declencherModale', declencherModale);

  getEtatModification = () => this.etatModification;
  saveEtatModification = (etatModification: string) => (this.etatModification = etatModification);

  getEtatErreur = () => this.etatErreur;
  saveEtatErreur = (etatErreur: HttpErrorResponse) => this.etatErreur.next(etatErreur);

  getFlowChangement = () => sessionStorage.getItem('typeChangement');
  saveFlowChangement = (flow: string) => sessionStorage.setItem('typeChangement', flow);
}
